import { DateUtil } from '@/utils';
import mutations from './accountDetailMutation';
import actions from './accountDetailAction';
import getters from './accountDetailGetter';

const state = {
  cnt: 0,
  gridData: {},
  searchParam: {
    domestic: '', // region
    gbmgroup: '', // rhq
    divisionCode: '', // 사업부
    cspCode: '', // CSP
    accountId: '', // Linked Account
    rootAccountId: '',
    projectName: '', // 프로젝트 명
    status: 'Active', // 계정 정상 여부
    searchPeriod: {}
  },
  item: {},
};

export default {
  state,
  mutations,
  actions,
  getters,
  DateUtil,
};



// WEBPACK FOOTER //
// ./src/vuex/monitoring/cloudaccount/detail/accountDetailStore.js